import { Icon, Icons } from 'components/Icon';
import React from 'react';
import { Bond } from 'service/dto/bond.dto';
import BondImg from '../../../assets/assets/bonds.png';

type Props = {
  asset: Bond;
  selectedAssetId?: number;
  handleShowDetails?: () => void;
};

export default function BondAsset({
  asset,
  selectedAssetId,
  handleShowDetails
}: Props) {
  return (
    <>
      <div className="border-b border-[#E5E5E5]">
        <div className="flex items-center justify-between p-3 px-5">
          <span className="text-base font-normal text-[#34475E]">Bonds</span>
          {handleShowDetails && (
            <button
              type="button"
              className={`cursor-pointer ${
                selectedAssetId === asset.id ? 'rotate-180' : ''
              }`}
              onClick={handleShowDetails}
            >
              <Icon name={Icons.ArrowDownCircle} />
            </button>
          )}
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between px-4 pb-1">
        <div className="mr-3 space-y-2">
          <img src={BondImg} className="h-[6.5rem] w-[6.5rem] object-contain" />
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Company Name
          </div>
          <div className="text-xs text-slate-600 ">{asset.issuerName}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">ISIN Number</div>
          <div className="text-xs text-slate-600 ">{asset.ISINNo}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">Currency</div>
          <div className="text-xs text-slate-600 ">{asset.currency}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Maturity Date
          </div>
          <div className="text-xs text-slate-600 ">{asset.maturityDate}</div>
        </div>
        {asset.totalBeneficiary ? (
          <div className="my-2 mr-3 space-y-2">
            <div className="text-xs font-medium text-slate-600 ">
              Number of Beneficaries
            </div>
            <div className="text-xs text-slate-600 ">
              {asset.totalBeneficiary}
            </div>
          </div>
        ) : (
          <div className="my-2 mr-3 space-y-2">
            <div className="text-xs font-medium text-slate-600 ">
              Account Type
            </div>
            <div className="text-xs text-slate-600 ">{asset.ISINNo}</div>
          </div>
        )}
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Percentage Alloted
          </div>
          <div className="text-xs text-slate-600 ">
            {asset.percentageAlloted}%
          </div>
        </div>
        <div className="my-2 mr-3 space-y-2"></div>
      </div>
    </>
  );
}
